var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header-helper',{attrs:{"id":"grosses-combined"}},[_c('span',[_c('span',[_vm._v("LW")]),_vm._v(" Last Week\n    ")]),_vm._v(" "),_c('span',[_c('span',[_vm._v("LS")]),_vm._v(" Last Season\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }